import React from 'react';
import { string, object } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const styles = {
  root: {
    flexGrow: 1,
    backgroundColor: 'red',
  },
  grow: {
    flexGrow: 1,
    color: 'white',
  },
};

class ErrorMsg extends React.Component {
  render() {
    const { classes, error } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="body1" color="inherit" className={classes.grow}>
          {error}
        </Typography>
      </div>
    );
  }
}

ErrorMsg.propTypes = {
  classes: object.isRequired,
  error: string.isRequired,
};

export default withStyles(styles)(ErrorMsg);



// WEBPACK FOOTER //
// ./src/view/scenes/components/ErrorMsg.js